import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_PUSH_TEMPLATE_LIST_REQUEST = 'FETCH_PUSH_TEMPLATE_LIST_REQUEST';
export const FETCH_PUSH_TEMPLATE_LIST_SUCCESS = 'FETCH_PUSH_TEMPLATE_LIST_SUCCESS';
export const FETCH_PUSH_TEMPLATE_LIST_FAILURE = 'FETCH_PUSH_TEMPLATE_LIST_FAILURE';

export const FETCH_PUSH_TEMPLATE_REQUEST = 'FETCH_PUSH_TEMPLATE_REQUEST';
export const FETCH_PUSH_TEMPLATE_SUCCESS = 'FETCH_PUSH_TEMPLATE_SUCCESS';
export const FETCH_PUSH_TEMPLATE_FAILURE = 'FETCH_PUSH_TEMPLATE_FAILURE';

export const EDIT_PUSH_TEMPLATE_REQUEST = 'EDIT_PUSH_TEMPLATE_REQUEST';
export const EDIT_PUSH_TEMPLATE_SUCCESS = 'EDIT_PUSH_TEMPLATE_SUCCESS';
export const EDIT_PUSH_TEMPLATE_FAILURE = 'EDIT_PUSH_TEMPLATE_FAILURE';

export const EDIT_PUSH_TEMPLATE_SEQUENCE_REQUEST = 'EDIT_PUSH_TEMPLATE_SEQUENCE_REQUEST';
export const EDIT_PUSH_TEMPLATE_SEQUENCE_SUCCESS = 'EDIT_PUSH_TEMPLATE_SEQUENCE_SUCCESS';
export const EDIT_PUSH_TEMPLATE_SEQUENCE_FAILURE = 'EDIT_PUSH_TEMPLATE_SEQUENCE_FAILURE';

const baseURL = 'agencies/config/templates/push';

export const fetchPushTemplateList = () => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [FETCH_PUSH_TEMPLATE_LIST_REQUEST, FETCH_PUSH_TEMPLATE_LIST_SUCCESS, FETCH_PUSH_TEMPLATE_LIST_FAILURE],
  },
});

export const fetchPushTemplate = (pushTemplateId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${pushTemplateId}`,
    method: 'get',
    authenticated: true,
    types: [FETCH_PUSH_TEMPLATE_REQUEST, FETCH_PUSH_TEMPLATE_SUCCESS, FETCH_PUSH_TEMPLATE_FAILURE],
  },
});

export const editPushTemplate = (pushTemplateId: number, pushTemplateData: IPushTemplateRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${pushTemplateId}`,
    method: 'put',
    body: pushTemplateData,
    authenticated: true,
    types: [EDIT_PUSH_TEMPLATE_REQUEST, EDIT_PUSH_TEMPLATE_SUCCESS, EDIT_PUSH_TEMPLATE_FAILURE],
  },
});

export const editPushTemplateSequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/sequence`,
    method: 'put',
    authenticated: true,
    body: { sequence },
    types: [
      EDIT_PUSH_TEMPLATE_SEQUENCE_REQUEST,
      EDIT_PUSH_TEMPLATE_SEQUENCE_SUCCESS,
      EDIT_PUSH_TEMPLATE_SEQUENCE_FAILURE,
    ],
  },
});
